import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { DateTime } from 'luxon';
import { initReactI18next } from 'react-i18next';

import en from './locales/en/translation.json';
import it from './locales/it/translation.json';
import { UnwrapLocalizationByPath, UnwrapLocalization } from './types';

export const I18N_RESOURCES = {
  en,
  it,
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // lng: 'it', // TODO: remove this
    debug: true,
    fallbackLng: 'en',
    resources: I18N_RESOURCES,
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (value instanceof Date && lng && format) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(DateTime[format]);
        }
        return value;
      },
    },
    returnObjects: true,
    react: {
      useSuspense: true,
    },
  });

export default i18n;

export type TranslationKeys = UnwrapLocalization<typeof en>;
export type TranslationKeysByPath<BasePath extends string> = UnwrapLocalizationByPath<typeof en, BasePath>;
